<template>
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5">
    <rect x="2.5" y="2.5" width="15" height="15" rx="3" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round"
      stroke-linejoin="round" />
    <path d="M8.75016 2.5V17.5" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5.8335 12.9167V7.5" stroke="#767BA2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
<script setup lang="ts"></script>